import { useCallback, useState } from 'react';

export function usePhotoSelection(orderedPhotoIds: string[]) {
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const [lastClicked, setLastClicked] = useState<string | null>(null);

  const handleClick = useCallback(
    (photoId: string, event: React.MouseEvent) => {
      setSelected((prev) => {
        const next = new Set(prev);

        if (event.shiftKey && lastClicked !== null) {
          const startIdx = orderedPhotoIds.indexOf(lastClicked);
          const endIdx = orderedPhotoIds.indexOf(photoId);
          if (startIdx !== -1 && endIdx !== -1) {
            const [from, to] = startIdx < endIdx ? [startIdx, endIdx] : [endIdx, startIdx];
            for (let i = from; i <= to; i++) {
              next.add(orderedPhotoIds[i]);
            }
          }
        } else if (event.metaKey || event.ctrlKey) {
          if (next.has(photoId)) {
            next.delete(photoId);
          } else {
            next.add(photoId);
          }
        } else {
          next.clear();
          next.add(photoId);
        }

        return next;
      });
      setLastClicked(photoId);
    },
    [orderedPhotoIds, lastClicked]
  );

  const clearSelection = useCallback(() => {
    setSelected(new Set());
    setLastClicked(null);
  }, []);

  return { selected, setSelected, handleClick, clearSelection };
}
